exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1gnOcX2kzjwAmJytoLZAux {\n  fill: currentColor;\n}\n", ""]);
// Exports
exports.locals = {
	"Icon": "_1gnOcX2kzjwAmJytoLZAux"
};